<template>
    <div>
        <div class="modal fade" id="modalShow" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true"
             style="position: fixed;">
            <button type="button" class="closeX" id="closeModal" data-dismiss="modal" aria-label="Close"
                    hidden></button>
            <div class="modal-dialog lg" role="document">
                <div class="modal-content">
                    <div data-cy="reserve_modal_title" class="modal-header hearder-custom">
                        <div>
                            <h4 class="modal-title">{{ t(modalTitle) }}</h4>
                            <button type="button" class="close close-custom" id="close" data-dismiss="modal"
                                    aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <div class="modal-body hearder-custom reserve-modal-body" v-if="wichModal == 3">
                        <SectionCardComponent
                                eyebrow="Atenção"
                                title="Interromper reserva"
                                subtitle="Revise os dados antes de confirmar a interrupção."
                                icon="icon-info-with-circle"
                                custom-class="reserve-modal-warning-card">
                            <div class="reserve-modal-alert">
                                Caso reserva possua proposta aprovada a mesma será rejeitada e suas assinaturas
                                eletrônicas canceladas.
                            </div>
                        </SectionCardComponent>

                        <SectionCardComponent
                                eyebrow="Reserva"
                                title="Dados vinculados"
                                subtitle="Informações principais da reserva que será interrompida."
                                icon="icon-grid"
                                custom-class="reserve-modal-section-card">
                            <div class="reserve-modal-info-grid">
                                <div class="reserve-modal-info-item reserve-modal-info-item--wide">
                                    <span>{{ t('LOTS.ALLOTMENT') }}</span>
                                    <strong>{{ nameAllotment }}</strong>
                                </div>
                                <div class="reserve-modal-info-item">
                                    <span>{{ t('LOTS.BLOCK') }}</span>
                                    <strong>{{ block }}</strong>
                                </div>
                                <div class="reserve-modal-info-item">
                                    <span>{{ t('LOTS.LOT') }}</span>
                                    <strong>{{ lot }}</strong>
                                </div>
                                <div class="reserve-modal-info-item reserve-modal-info-item--wide">
                                    <span>{{ t('RESERVE.REALTOR') }}</span>
                                    <strong>{{ realtor }}</strong>
                                </div>
                            </div>
                        </SectionCardComponent>

                        <SectionCardComponent
                                eyebrow="Motivo"
                                title="Justificativa da interrupção"
                                subtitle="Informe o motivo com no mínimo 10 caracteres."
                                icon="icon-pencil"
                                custom-class="reserve-modal-section-card">
                            <div class="form-group mb-0">
                                <label for="reason_revocation" class="required">Motivo para Interromper a reserva:</label>
                                <textarea class="form-control reserve-modal-textarea" id="reason_revocation" cols="20" rows="6"
                                          v-model="reasonRevocation">
                                </textarea>
                                <p class="red reserve-modal-help-text">Mínimo 10 caracteres</p>
                            </div>
                        </SectionCardComponent>

                        <div class="reserve-modal-footer-actions">
                            <button data-cy="reserve_modal_close" type="button"
                                    class="btn btn-secondary mr-1 width-buttons" data-dismiss="modal">
                                {{ t('ACTIONS.CLOSE') }}
                            </button>
                            <button data-cy="reserve_modal_confirm" type="button"
                                    class="btn btn-primary mr-1 width-buttons" @click="drop(reserve.id)">
                                {{ t('ACTIONS.CONFIRM') }}
                            </button>
                        </div>
                    </div>

                    <div class="modal-body hearder-custom reserve-modal-body" v-if="wichModal == 4">
                        <SectionCardComponent
                                eyebrow="Reserva"
                                title="Informações gerais"
                                subtitle="Resumo dos principais dados vinculados à reserva."
                                icon="icon-info-with-circle"
                                custom-class="reserve-modal-section-card">
                            <template #actions>
                                <span class="reserve-modal-status-badge">{{ reserveIndex.reserve_status.name }}</span>
                            </template>

                            <div class="reserve-modal-info-grid">
                                <div class="reserve-modal-info-item reserve-modal-info-item--wide">
                                    <span>Corretor</span>
                                    <strong>{{ reserveIndex.realtor }}</strong>
                                </div>
                                <div class="reserve-modal-info-item">
                                    <span>{{ t('PROPERTIES.BLOCK') }}</span>
                                    <strong>{{ reserveIndex.properties.block }}</strong>
                                </div>
                                <div class="reserve-modal-info-item">
                                    <span>{{ t('PROPERTIES.NAME') }}</span>
                                    <strong>{{ reserveIndex.properties.name }}</strong>
                                </div>
                                <div class="reserve-modal-info-item reserve-modal-info-item--wide" v-if="reserveHistoric.confirmed_at">
                                    <span>Confirmada em</span>
                                    <strong>{{ formatDateConfirm(reserveHistoric.confirmed_at) }}</strong>
                                </div>
                            </div>
                        </SectionCardComponent>

                        <SectionCardComponent
                                eyebrow="Histórico"
                                title="Períodos da reserva"
                                subtitle="Datas de início e finalização registradas para esta reserva."
                                icon="icon-calendar"
                                custom-class="reserve-modal-section-card">
                            <div class="table-responsive text-center reserve-modal-history-table">
                                <table class="table table-bordered table-striped mb-0">
                                    <thead>
                                    <tr>
                                        <th>{{ t('RESERVE.START_RESERVE') }}</th>
                                        <th>{{ t('RESERVE.FINISH_RESERVE') }}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="historic in histories" :key="historic.id">
                                        <td :style="{'font-weight': historic.active ? 'bold':'normal'}">
                                            {{ dateFormat(historic.start) }}
                                        </td>
                                        <td :style="{'font-weight': historic.active ? 'bold':'normal'}">
                                            {{ dateFormat(historic.finish) }}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </SectionCardComponent>

                        <SectionCardComponent
                                v-if="reserve?.observation || reserveIndex.reserve_status.name === 'Interrompido'"
                                eyebrow="Detalhes"
                                title="Observações e interrupção"
                                subtitle="Registros complementares associados à reserva."
                                icon="icon-pencil"
                                custom-class="reserve-modal-section-card">
                            <div class="row gutters">
                                <div :class="reserveIndex?.reserve_status?.name === 'Interrompido' ?
                                'col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12' :'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'"
                                     v-if="reserve?.observation">
                                    <div class="form-group">
                                        <label for="exampleFormControlTextarea1">Observações:</label>
                                        <textarea class="form-control reserve-modal-textarea" id="exampleFormControlTextarea1" rows="6" disabled
                                                  v-model="reserve.observation"></textarea>
                                    </div>
                                </div>
                                <div :class="reserve?.observation ? 'col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12' : 'col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'"
                                     v-if="reserveIndex.reserve_status.name === 'Interrompido'">
                                    <div class="form-group">
                                        <label for="reason_revocation_history"> {{ t('RESERVE.HISTORIC_MOTIVE_INTERRUPED') }}:</label>
                                        <textarea class="form-control reserve-modal-textarea" id="reason_revocation_history" cols="20" rows="6"
                                                  v-model="reasonRevocationShow" disabled>
                                        </textarea>
                                    </div>
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" v-if="reserveIndex.reserve_status.name === 'Interrompido'">
                                    <div class="form-group mb-0">
                                        <label for="reason_revocation_history">{{ t('RESERVE.HISTORIC_REVOGED_BY') }}:</label>
                                        <input type="text" disabled class="form-control" v-model="reserveHistoric.revokedByName">
                                    </div>
                                </div>
                            </div>
                        </SectionCardComponent>

                        <div class="reserve-modal-footer-actions">
                            <button type="button" class="btn btn-secondary mr-1 mt-2" data-dismiss="modal">
                                {{ t('ACTIONS.CLOSE') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {useI18n} from "vue-i18n";
import Reserve from "@/services/Reserves";
import {useToast} from "vue-toastification";
import Validate from '@/components/validate.vue';
import Permission from '@/components/permission.vue';
import SectionCardComponent from '@/components/layouts/SectionCardComponent.vue';

export default {
    name: 'dropReserve',
    mixins: [Permission, Validate],
    components: {SectionCardComponent},
    props: ['reserveIndex', 'modalTitle', 'wichModal'],

    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },

    data() {
        return {
            reserveHistoric: {},
            reasonRevocation: null,
            reasonRevocationShow: null,
            lot: null,
            block: null,
            histories: [],
            realtor: null,
            reserve: null,
            properties: null,
            nameAllotment: null,
        }
    },

    mounted() {
        this.reasonRevocation = null;
        this.reasonRevocationShow = null;
        this.reserve = this.reserveIndex;
        this.realtor = this.reserve.realtor;
        this.properties = this.reserve.properties;
        this.lot = this.properties.name;
        this.block = this.properties.block;
        this.nameAllotment = this.properties.allotments?.name;
        this.indexHistoric(this.reserveIndex.id, this.reserveIndex.properties.allotment_id);
    },
    emits:['drop'],
    watch: {
        reserveIndex: function () {
            this.reasonRevocation = null;
            this.reasonRevocationShow = null;
            this.histories = [];
            this.reserve = this.reserveIndex;
            this.properties = this.reserve.properties;

            this.lot = this.properties.name;
            this.block = this.properties.block;
            this.nameAllotment = this.properties.allotments.name;

            this.indexHistoric(this.reserveIndex.id, this.reserveIndex.properties.allotment_id);
        },
    },

    methods: {
        formatDateConfirm(date)
        {
            if (!date) return "";
            date = date.split(" ");
            let time = date[1];
            date = date[0].split("-");
            return `${date[2]}-${date[1]}-${date[0]} às ${time}`;
        },
        drop(reserve_id) {
            this.reasonRevocation = this.reasonRevocation?.trim();
            if (!this.reasonRevocation?.length || this.reasonRevocation?.length < 10) {
                this.toast.error('Necessário informar a razão que levou a interromper esta reserva; Com no mínimo 10 caracteres.');
                return;
            }
            this.$store.commit('changeLoading', true);
            Reserve.drop(reserve_id, this.reserve.properties.allotment_id, this.reasonRevocation).then(() => {
                document.getElementById('closeModal').click();
                this.toast.success(this.t('GENERAL.MSG.RESERVE_DROP_SUCCESSED'));
                this.$emit('drop');
                this.$store.commit('changeLoading', false);
            }).catch(error => {
                this.errorMsg(error);
                this.$store.commit('changeLoading', false);
            });
        },

        indexHistoric(reserveId, allotment_id) {
            Reserve.historic(reserveId, allotment_id).then(resp => {
                this.reserveHistoric = resp.data.reserve;
                let reserve = resp.data.reserve;
                delete resp.data.reserve;
                this.reasonRevocationShow = reserve.reason_revocation;
                this.histories = resp.data;
                this.$store.commit('changeLoading', false);
            }).catch(error => {
                this.errorMsg(error);
                this.$store.commit('changeLoading', false);
            });
        },

        dateFormat(value) {
            if (value) {
                let onlyData = value.split(' ');
                let data = onlyData[0].split('-');

                value = data[2] + '/' + data[1] + '/' + data[0] + ' ás ' + onlyData[1];

                let time = value.split(':');

                return time[0] + ":" + time[1];
            } else {
                return '?';
            }
        }
    }
}
</script>

<style>
.right {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end !important;
    border-bottom-right-radius: calc(.3rem - 1px);
    border-bottom-left-radius: calc(.3rem - 1px);
}

.name {
    margin: auto !important;
    border-radius: 3px;
    padding-bottom: 1px;
    padding-top: 6px;
}

.secondary {
    border-radius: 3px;
    color: #ffffff !important;
    background-color: #383737;
}

.full-border {
    border-radius: 2px !important;
    border-bottom: 1px solid #dbd4d4 !important;
    border-top: 1px solid #dbd4d4 !important;
    border-left: 1px solid #dbd4d4 !important;
    border-right: 1px solid #dbd4d4 !important;
}

.hearder-custom {
    color: #333333 !important;
    background: #ffffff !important;
}

.close-custom {
    color: #000 !important;
}

.modal-title {
    padding-bottom: 1rem;
}

.value {
    font-size: .8rem;
    font-weight: 400;
}

.custom-margin {
    height: 24px !important;
}

.width-buttons {
    width: 30%;
}

.margin-historic {
    padding-top: 1rem;
    padding-left: 1rem;
}

.border-red {
    border-color: #d64c36;
}

.card-custom {
    margin-bottom: 0rem;
}

.mt-custom {
    margin-top: 1rem;
}

.margin-historic {
    padding-top: 1rem;
    padding-left: 1rem;
}

.modal-header {
    padding-bottom: 0em !important;
}

.modal-body {
    padding-top: 0em !important;
}

.card-info {
    padding: 0.5rem;
    font-size: .840rem;
}

.user-card {
    padding-top: 0.1em !important;
    padding-bottom: 0.5em !important;
}

.alin-between {
    justify-content: space-between !important;
}

.reserve-modal-body {
    padding: 0 1rem 1rem !important;
}

.reserve-modal-section-card,
.reserve-modal-warning-card {
    margin-bottom: 12px !important;
}

.reserve-modal-warning-card {
    border-color: rgba(214, 76, 54, 0.22) !important;
}

.reserve-modal-alert {
    background: rgba(214, 76, 54, 0.08);
    border-left: 4px solid #d64c36;
    border-radius: 10px;
    color: #6f2b21;
    font-size: 0.86rem;
    font-weight: 700;
    line-height: 1.35;
    padding: 0.75rem 0.9rem;
}

.reserve-modal-info-grid {
    display: grid;
    gap: 0.65rem;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-bottom: 12px;
}

.reserve-modal-info-item {
    background: rgba(231, 244, 240, 0.52);
    border: 1px solid rgba(14, 94, 78, 0.08);
    border-radius: 12px;
    min-width: 0;
    padding: 0.65rem 0.75rem;
}

.reserve-modal-info-item--wide {
    grid-column: span 2;
}

.reserve-modal-info-item span {
    color: #6b7c78;
    display: block;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    margin-bottom: 0.15rem;
    text-transform: uppercase;
}

.reserve-modal-info-item strong {
    color: #173b34;
    display: block;
    font-size: 0.9rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.reserve-modal-status-badge {
    background: #e7f4f0;
    border-radius: 999px;
    color: #0e5e4e;
    display: inline-flex;
    font-size: 0.75rem;
    font-weight: 700;
    padding: 0.45rem 0.7rem;
    white-space: nowrap;
}

.reserve-modal-history-table {
    border-radius: 12px;
    overflow: hidden;
}

.reserve-modal-history-table .table th {
    background: #e7f4f0;
    border-color: rgba(14, 94, 78, 0.12);
    color: #0e5e4e;
    font-size: 0.78rem;
    white-space: nowrap;
}

.reserve-modal-history-table .table td {
    vertical-align: middle;
}

.reserve-modal-textarea {
    min-height: 120px;
    resize: vertical;
}

.reserve-modal-help-text {
    font-size: 0.75rem;
    font-weight: 700;
    margin: 0.35rem 0 0;
}

.reserve-modal-footer-actions {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    padding-top: 0.25rem;
}

html.dark-theme .reserve-modal-alert {
    background: rgba(251, 113, 133, 0.12) !important;
    border-left-color: var(--dark-danger) !important;
    color: var(--dark-text) !important;
}

html.dark-theme .reserve-modal-info-item,
html.dark-theme .reserve-modal-status-badge,
html.dark-theme .reserve-modal-history-table .table th {
    background: var(--dark-primary-soft) !important;
    border-color: var(--dark-border) !important;
    color: var(--dark-primary) !important;
}

html.dark-theme .reserve-modal-info-item span {
    color: var(--dark-text-soft) !important;
}

html.dark-theme .reserve-modal-info-item strong {
    color: var(--dark-text) !important;
}

@media (max-width: 575px) {
    .reserve-modal-info-grid {
        grid-template-columns: 1fr;
    }

    .reserve-modal-info-item--wide {
        grid-column: span 1;
    }

    .reserve-modal-footer-actions .btn {
        margin-bottom: 0.35rem;
        width: 100%;
    }
}
</style>
